// components/OwnerPrivateRoute.js
import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from './context/AuthContext';
import useOwnerAuthCheck from './hooks/useOwnerAuthCheck';
import OwnerLoginDialog from './OwnerLoginDialog'; // You'll need to create this component

const OwnerPrivateRoute = ({ children }) => {
  const { isOwnerAuthenticated } = useAuth();
  const { isTokenValid, showLoginDialog, setShowLoginDialog } =
    useOwnerAuthCheck();
  const location = useLocation();

  if (!isOwnerAuthenticated || !isTokenValid) {
    // if (showLoginDialog) {
    //   return (
    //     <>
    //       {children}
    //       <OwnerLoginDialog
    //         onClose={() => setShowLoginDialog(false)}
    //         onLogin={() => {}} // Handle login
    //       />
    //     </>
    //   );
    // }
    return <Navigate to='/owner/login' state={{ from: location }} replace />;
  }

  return children;
};

export default OwnerPrivateRoute;

// // components/OwnerPrivateRoute.js
// import React from 'react';
// import { Route, Redirect } from 'react-router-dom';
// import { useAuth } from '../context/AuthContext';

// const OwnerPrivateRoute = ({ component: Component, ...rest }) => {
//   const { isOwnerAuthenticated } = useAuth();

//   return (
//     <Route
//       {...rest}
//       render={(props) =>
//         isOwnerAuthenticated ? (
//           <Component {...props} />
//         ) : (
//           <Redirect
//             to={{
//               pathname: '/owner-login',
//               state: { from: props.location },
//             }}
//           />
//         )
//       }
//     />
//   );
// };

// export default OwnerPrivateRoute;
